module.exports = __webpack_public_path__ + "static/media/hindsightHero.9634702e.jpg";